import { computed, defineComponent } from 'vue';
import { CreateContextualCommentButtonState } from '@getaccept/lib-shared-new/src/contextual-commenting/types/create-contextual-comment-button-state';
import { t } from '@getaccept/lib-shared-new/src/helpers/translation.helper';
import useBreakpoints from '@getaccept/lib-shared-new/src/composables/breakpoints.composable';
export default defineComponent({
    props: {
        position: {
            type: Object,
            required: true,
        },
        state: {
            type: String,
            required: true,
        },
    },
    emits: ['click'],
    setup(props) {
        const disabled = computed(() => props.state !== CreateContextualCommentButtonState.Enabled);
        const { isXXSmallScreen } = useBreakpoints();
        const mobileDeviceTopOffset = 70;
        const top = computed(() => {
            if (isXXSmallScreen.value) {
                return props.position.top + mobileDeviceTopOffset;
            }
            return props.position.top;
        });
        const mobileDeviceLeftOffset = 75;
        const left = computed(() => {
            if (isXXSmallScreen.value) {
                return props.position.left - mobileDeviceLeftOffset;
            }
            return props.position.left;
        });
        const tooltipText = computed(() => {
            switch (props.state) {
                case CreateContextualCommentButtonState.YouAreNotTheSender:
                    return t('cc_tooltip_colleague_not_doc_owner');
                case CreateContextualCommentButtonState.DocumentIsNotEligible:
                    return t('cc_tooltip_document_not_eligible');
                case CreateContextualCommentButtonState.ContentUpdatePending:
                    return t('cc_tooltip_content_updating');
                case CreateContextualCommentButtonState.SenderHasMadeChanges:
                    return t('cc_tooltip_new_comments_disabled');
                case CreateContextualCommentButtonState.DocumentHasUnpublishedChanges:
                    return t('cc_tooltip_unpublished_changes');
                case CreateContextualCommentButtonState.Enabled:
                default:
                    return t('cc_tooltip_add_comment');
            }
        });
        return {
            t,
            tooltipText,
            disabled,
            top,
            left,
        };
    },
});
